// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"c6ef8d83","513":"4ef5c339","703":"e0477584","787":"1e45fb75"}[chunkId] + ".chunk.js";
};